import { render } from "./VerifyEmail.vue?vue&type=template&id=23a183f8&ts=true"
import script from "./VerifyEmail.vue?vue&type=script&lang=ts"
export * from "./VerifyEmail.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src669166032/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__